import { render, staticRenderFns } from "./cpo-tagged-summary.vue?vue&type=template&id=1e7a725a&scoped=true&"
import script from "./cpo-tagged-summary.vue?vue&type=script&lang=js&"
export * from "./cpo-tagged-summary.vue?vue&type=script&lang=js&"
import style0 from "./cpo-tagged-summary.vue?vue&type=style&index=0&id=1e7a725a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7a725a",
  null
  
)

export default component.exports